<div [formGroup]="formComponent" class="grid-x">
  <div class="cell">
    <label for="name">Name:</label>
    <input id="name" type="text" formControlName="name" required />
  </div>
  @if (name.invalid && (name.dirty || name.touched)) {
    <div class="error-container cell">
      @if (name.errors.required) {
        <small class="error">Name is required.</small>
      }
      @if (name.errors.minlength) {
        <small class="error">Name must be at least 4 characters long.</small>
      }
    </div>
  }
  <label for="allowEdit">
    Allow Edits?
    <input id="allowEdit" type="checkbox" formControlName="allowEdit" [value]="allowEdit" />
  </label>
  <div class="cell">
    <label for="name">Display Name:</label>
    <input id="displayName" type="text" formControlName="displayName">
  </div>
  <fieldset class="cell">
    <label for="numberType">
      Integer?
      <input id="numberType" type="checkbox" formControlName="numberType" [value]="numberType" />
    </label>
  </fieldset>
</div>